import React, { Component } from "react";

import { MdRefresh } from "react-icons/md";
import COLORS from "scss/colors.module.scss";

export default class RefreshData extends Component {
  render() {
    return (
      <div className="d-flex" style={{ margin: 3 }}>
        <div
          className="d-flex actions"
          style={{ cursor: "pointer", padding: 5, borderRadius: 4 }}
        >
          <MdRefresh
            size={20}
            color={COLORS.TEXT_COLOR}
            onClick={() => this.props.store.refreshData(true)}
          />
        </div>
      </div>
    );
  }
}
